module.exports = __webpack_public_path__ + "img/co_es.296eed5e.jpg";